import Card from "components/card";
import CardMenu from "components/card/CardMenu";
import React from "react";
import { BsCloudCheck } from "react-icons/bs";
const Storage = ({ storage }) => {
  // Helpers
  const formatBytes = (bytes) => {
    if (!bytes) return "0 B";
    if (bytes < 1024) return `${bytes} B`;
    const units = ["KB", "MB", "GB", "TB"];
    let value = bytes / 1024;
    let unit = 0;
    while (value >= 1024 && unit < units.length - 1) {
      value /= 1024;
      unit += 1;
    }
    return `${value.toFixed(1)} ${units[unit]}`;
  };

  const totalBytes = storage?.totalBytes || 0;
  const freeBytes = (storage?.cost?.freeGb || 10) * 1024 * 1024 * 1024; // Convert GB to Bytes
  const percentage = Math.min((totalBytes / freeBytes) * 100, 100).toFixed(1);

  return (
    <Card extra={"w-full h-full p-4"}>
      <div className="ml-auto">
        <CardMenu />
      </div>
      {/* Your storage */}
      <div className="mb-auto flex flex-col items-center justify-center">
        <div className="mt-2 flex items-center justify-center rounded-full bg-lightPrimary p-[26px] text-5xl font-bold text-brand-500 dark:!bg-navy-700 dark:text-white">
          <BsCloudCheck />
        </div>
        <h4 className="mb-px mt-3 text-2xl font-bold text-navy-700 dark:text-white">
          Your Storage
        </h4>
        <p className="px-5 text-center text-base font-normal text-gray-600 md:!px-0 xl:!px-8">
          Manage your R2 Cloudflare space
        </p>
      </div>

      {/* Progress bar */}
      <div className="flex flex-col mt-6">
        <div className="flex justify-between">
          <p className="text-sm font-medium text-gray-600">{formatBytes(totalBytes)} Used</p>
          <p className="text-sm font-medium text-gray-600">{storage?.cost?.freeGb || 10} GB Free Tier</p>
        </div>
        <div className="mt-2 flex h-3 w-full items-center rounded-full bg-lightPrimary dark:!bg-navy-700">
          <span 
            className={`h-full rounded-full ${percentage > 90 ? 'bg-red-500' : 'bg-brand-500'} dark:!bg-white`} 
            style={{ width: `${percentage}%` }}
          />
        </div>
        <p className="text-xs text-gray-400 mt-2 text-center">
          Estimated Bill: <span className="font-bold text-navy-700 dark:text-white">${storage?.cost?.estimatedMonthlyUsd?.toFixed(2) || "0.00"} / mo</span>
        </p>
        <p className="text-[11px] text-gray-400 mt-1 text-center">
          Rough estimate from today's storage snapshot, not your actual invoice — Cloudflare bills on average daily usage across the month, so this runs high right after a big upload. Check the Cloudflare dashboard for the real bill.
        </p>
      </div>
    </Card>
  );
};

export default Storage;
